import React from 'react';
import styled, { keyframes } from 'styled-components';

const BlurredLines = () => {

  return <Container>
    <Light $offset={4} $size={1.0}/>
    <Light $offset={7} $size={1.6} $left="15%"/>
    <Light $offset={2.5} $size={.5} $left="-15%"/>
    <Light $offset={4.5} $size={1.2} $left="-34%"/>
    <Light $offset={8} $size={2.2} $left="-57%"/>
    <Light $offset={3} $size={.8} $left="-81%"/>
    <Light $offset={5.3} $size={3.2} $left="37%"/>
    <Light $offset={4.7} $size={1.7} $left="62%"/>
    <Light $offset={4.1} $size={0.9} $left="85%"/>
  </Container>;
}

const Container = styled.div`
  width: 100%;
  height: 100%;
  background: radial-gradient(var(--shine-secondary-bg-color), var(--shine-bg-color));
  overflow-y: hidden;
`;

const FloatUp = keyframes`
  0% {
    top: 100vh;
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  50% {
    top: 0;
    opacity: .8;
  }
  75% {
    opacity: 1;
  }
  100% {
    top: -100vh;
    opacity: 0;
  }
`;

const BaseLight = styled.div`
  position: absolute;
  width: 0;
  background-color: white;
  box-shadow: #e9f1f1 0 0 20px 2px;
  top: 100vh;
  bottom: 0;
  right: 0;
  margin: auto;
`;

const Light = styled(BaseLight)<{$offset: number, $size: number, $left?: string}>`
  left: ${({ $left = '0' }) => $left};
  animation: ${FloatUp} ${({ $offset }) => $offset}s infinite linear;
  transform: scale(${({ $size }) => $size});
`;

export default BlurredLines;
